import { Component, Inject } from '@angular/core'
import { MatCard } from '@angular/material/card'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogClose,
} from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

@Component({
  selector: 'dialog-to-choose-unique',
  imports: [MatCard, MatDialogClose, MatIcon, MatButton, MatProgressSpinner],
  templateUrl: './dialog-to-choose-unique.component.html',
  styleUrl: './dialog-to-choose-unique.component.scss',
})
export class DialogChooseUniqueComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
